import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mapPluginDataToSettings(data) {
  if (!data) {
    throw new Error("Plugin data is undefined");
  }
  var whitecolor = "rgb(255, 255, 255)";
  var lgreyColor = "rgb(238, 238, 238)";
  var dgreyColor = "rgb(174, 174, 174)";
  var primarycolorHeader = data.consent_plugin_header_background_color;
  var primarycolorMain = data.consent_plugin_theme_main_color;
  var backButton = data.consent_plugin_labelBackButton;
  var cookiesLabel = data.consent_plugin_labelCookies;
  var dataURLLabel = data.consent_plugin_labelDataUrl;
  var durationLabel = data.consent_plugin_labelDuration;
  var hostsLabel = data.consent_plugin_labelHosts;
  var providerLabel = data === null || data === void 0 ? void 0 : data.consent_plugin_labelProvider;
  var individualButton = data.consent_plugin_labelIndividualButton;
  var nameLabel = data.consent_plugin_labelName;
  var purposeLabel = data.consent_plugin_labelPurpose;
  var saveAllButton = data.consent_plugin_labelSaveAllButton;
  var saveButton = data.consent_plugin_labelSaveButton;
  var allowRequired = data.consent_plugin_label_allow_required;
  var headerImage = typeof data.consent_plugin_header_image !== "undefined" ? data.consent_plugin_header_image.url : "";
  return {
    labels: {
      backButton: backButton,
      cookiesLabel: cookiesLabel,
      dataURLLabel: dataURLLabel,
      durationLabel: durationLabel,
      hostsLabel: hostsLabel,
      providerLabel: providerLabel,
      individualButton: individualButton,
      nameLabel: nameLabel,
      purposeLabel: purposeLabel,
      saveAllButton: saveAllButton,
      saveButton: saveButton,
      allowRequired: allowRequired
    },
    colors: {
      white: whitecolor,
      primary: primarycolorMain,
      lightgrey: lgreyColor,
      darkgrey: dgreyColor
    },
    links: {
      color: primarycolorMain
    },
    logo: _objectSpread({
      styles: {
        borderRadius: data.consent_plugin_logo_background_radius + "%"
      },
      src: typeof data.consent_plugin_logo !== "undefined" ? data.consent_plugin_logo.url : ""
    }, data.consent_plugin_logo),
    logoBG: {
      styles: {},
      classes: "mx-6 has-text-" + data.consent_plugin_logo_position
    },
    header: {
      styles: _objectSpread(_objectSpread({}, headerImage && {
        backgroundImage: "url(" + headerImage + ")"
      }), {}, {
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundColor: primarycolorHeader
      })
    },
    switcher: {
      styles: {
        backgroundColor: primarycolorMain
      }
    },
    textcolor: {
      color: primarycolorMain
    },
    footer: {
      links: {
        styles: {
          color: primarycolorMain
        }
      },
      buttons: {
        styles: {
          filled: {
            color: whitecolor,
            backgroundColor: primarycolorMain,
            borderColor: primarycolorMain
          },
          outlined: {
            color: primarycolorMain,
            backgroundColor: whitecolor,
            borderColor: primarycolorMain
          }
        }
      }
    }
  };
}
var WRAPPER_COOKIE_NAME = "aunds-cookie";
var TEMPORARY_CONSENT_BASE_KEY = "temporary-consent";

export { TEMPORARY_CONSENT_BASE_KEY, WRAPPER_COOKIE_NAME, mapPluginDataToSettings };
//# sourceMappingURL=utils.js.map
